import React from "react";
import { Building2, ChevronLeft, ChevronRight, ClipboardCheck, Clock } from "lucide-react";
import { SECONDARY } from "./Fields.jsx";
import { WorkspaceBand, WorkspaceKpi, WorkspaceKpis, WorkspaceTab } from "../billing/WorkspaceBand.jsx";

export const CONSOLIDATION_VIEWS = [["sheets", "Journées du Dispatch"], ["summary", "Prestations par entreprise"], ["hours", "Heures des chauffeurs"]];
const VIEW_ICONS = { sheets: ClipboardCheck, summary: Building2, hours: Clock };
const MODES =[["day", "Jour"], ["week", "Semaine"], ["month", "Mois"]];
const ICON = `${SECONDARY} !h-7 !w-7 !p-0`;
const TONES = { ok: ["done", "text-accent"], wait: ["progress", "text-[#a86a24]"], alert: ["blocked", "text-[#c5524a]"] };

// En-tête commun aux trois onglets : période, indicateurs et compteurs de ce qui reste à faire.
// Bande ardoise partagée avec la Facturation.
// tabsSlot : emplacement à droite des onglets (bandeau « Dispatch modifié » replié).
export default function ConsolidationHeader({ views = CONSOLIDATION_VIEWS, view, onView, title, onPrevious, onNext, picker, mode, onMode, kpis = [], counters = {}, tabsRight, tabsSlot, disabled }) {
  return <div className="grid min-w-0 gap-2">
    <WorkspaceBand icon={ClipboardCheck} title="Consolidation" titleAs="p" tabsSlot={tabsSlot} tabsRight={tabsRight}
      subtitle={<>
        <button type="button" className={ICON} aria-label="Période précédente" disabled={disabled} onClick={onPrevious}><ChevronLeft size={16} aria-hidden="true" /></button>
        <h1 className="text-[15px] font-bold text-white">{title}</h1>
        <button type="button" className={ICON} aria-label="Période suivante" disabled={disabled} onClick={onNext}><ChevronRight size={16} aria-hidden="true" /></button>
        {picker}
        {onMode ? <div role="group" aria-label="Période" className="ml-1 inline-flex overflow-hidden rounded-[4px] border border-slate-300">
          {MODES.map(([key, label]) => <button key={key} type="button" aria-pressed={mode === key} disabled={disabled} onClick={() => onMode(key)}
            className={`h-7 border-r border-slate-300 px-2.5 text-xs font-semibold last:border-r-0 focus-visible:outline-2 focus-visible:outline-accent ${mode === key ? "bg-accent text-white" : "bg-white text-slate-700 hover:bg-slate-50"}`}>{label}</button>)}
        </div> : null}
      </>}
      tabs={views.map(([key, label]) => <WorkspaceTab key={key} icon={VIEW_ICONS[key]} active={view === key} count={counters[key]} onClick={() => onView(key)}>{label}</WorkspaceTab>)} />
    {kpis.length ? <WorkspaceKpis label="Indicateurs de consolidation">
      {kpis.map(kpi => <WorkspaceKpi key={kpi.label} compact tone={TONES[kpi.tone]?.[0]} label={kpi.label} value={kpi.value} sub={kpi.sub} valueClassName={TONES[kpi.tone]?.[1]} />)}
    </WorkspaceKpis> : null}
  </div>;
}

